export default __webpack_public_path__ + "static/media/plus.529fc7fe.svg";